const morningsideQuoteData = {
  meta: {
    title: "Morningside Chiropractic Website Quote",
    clientName: "Morningside Chiropractic",
    url: "https://mornignsidechiro.com.au",
    date: "2026-01-06",
    quoteNumber: "Q1-2026-MOR",
    preparedBy: "Jason Toomer",
   summary: [
  "Hi Jack, thanks again for confirming you want to move forward with the Morningside Chiropractic website build.",
  "We’re excited to help get your new business off the ground with a dynamic, mobile-first website focused on performance, clear user navigation, and search-prioritised structure.",
  "The site will be fast, calm, and easy to use, designed to build trust with prospective patients and guide them confidently to take action.",
  "",
  "While not strictly part of the website build itself, I strongly recommend the included Google Business Profile optimisation. This allows us to align your online presence and help prospective clients discover you sooner through local search.",
  "",
  "<strong>Summary</strong>",
  "Domain purchase and setup (pass-through): <strong>$20</strong>",
  "Website build (React + unique design + booking integration + contact form): <strong>$3,900</strong>",
  "Brand logo creation + colour palette (web + print formats): <strong>$650</strong>",
  "Advanced SEO + GEO setup (metadata + schema + sitemap): <strong>$750</strong>",
  "Google Business Profile optimisation (one-off): <strong>$250</strong>",
  "Hosting + 2 professional email address: <strong>$260 per year</strong>",
  "",
  "This is not a set-and-walk-away build. 2merative Web Design, led by Jason, will be here to support you as your needs and practice grow over time.",
],
  },

  business: {
    name: "2merative Web Design",
    abn: "",
    email: "hello@2merative.com",
    phone: "+61 498 135744",
  },

  gstRate: 0,

  notes: [
  "All pricing is exclusive of GST. GST is not charged as the business is not currently registered for GST.",
  "Domain registration is a pass-through cost billed at cost price. Renewal is billed yearly at cost price unless otherwise agreed.",
  "Third-party platform fees (including booking system fees) are paid directly by the owner unless explicitly stated otherwise.",
  "All website copy will be written and reviewed for AHPRA-safe language and will avoid clinical, comparative, or guaranteed outcome claims.",
  "The website is planned to launch on 16 February 2026. This early launch supports awareness building and search visibility ahead of opening.",
  "The target business opening date is 16 March 2026, allowing the website to establish momentum in local search and discovery prior to launch.",
],

  assumptionsExclusions: [
  "Owner supplies all website wording and images (including service descriptions, practitioner bio, location details, and any FAQs).",
  "Stock images can be supplied if requested.",
  "If content is not supplied in time, placeholders will be used to keep the build moving until final content is provided.",
  "Light assistance with copy structure, clarity, and refinement is included. Full copywriting or content strategy beyond this can be added if required.",
  "Photography, videography, and custom illustration are not included unless quoted separately.",
  "Patient portals, online payments, intake forms, membership systems, and custom web applications are not included unless quoted separately.",
  "Ongoing SEO content marketing (blogs, ongoing landing page expansion, backlink campaigns) is not included unless quoted separately.",
],

  warrantySupport: [
    "Any major scope changes or feature additions will be quoted and approved before work proceeds.",
    "Post-launch support is available on a pay-as-you-go basis or optional monthly retainer support if you prefer predictable ongoing help.",
  ],

  acceptance: {
    validUntil: "2026-02-06",
    paymentTerms: "50% deposit to commence. Balance due prior to launch.",
  },

  options: [
    {
      label: "React Website Build (Morningside Chiropractic)",
      sections: {
        projectApproach: [
  "Build a new, fast React website hosted on Hostinger.",
  "Mobile-first layout with clear calls to action and simple navigation.",
  "Persistent mobile tap-to-call button for quick contact on phones.",
  "Ticker-style offer banner for time-sensitive or introductory offers.",
  "Optional pop-up offer banner to highlight key promotions or announcements.",
  "AHPRA-safe structure and wording across all pages.",
  "Up to 15 pages included (more can be added if required).",
  "Booking platform integration (PracSuite confirmed).",
  "Contact form with spam protection.",
  "Advanced SEO + GEO setup including titles, meta descriptions, Open Graph, sitemap.xml, robots.txt, clean URLs, and structured data where appropriate.",
  "Performance optimisation including lean CSS, deferred scripts, image optimisation, and Core Web Vitals targets.",
  "Accessibility and UX best practices including readable layout and keyboard-friendly navigation.",
  "Optimise supplied assets for web performance.",
  "Unique design tailored to Morningside Chiropractic.",
  "Google Business Profile optimisation to align categories, services, descriptions, photos, and website signals.",
],
        oneOff: [
          { item: "Domain registration (mornignsidechiro.com.au) and DNS setup (pass-through)", cost: 20 },
          { item: "Holding page setup (during build)", cost: 0 },
          { item: "Brand logo creation + colour palette (web + print formats)", cost: 650 },
          { item: "React website build (design + build + setup)", cost: 3900 },
          { item: "Booking platform integration (PracSuite confirmed)", cost: 0 },
          { item: "Advanced SEO + GEO setup (metadata + schema + sitemap)", cost: 750 },
          { item: "Google Business Profile optimisation (one-off)", cost: 250 },
          
        ],
        recurring: [
          {
            item: "Website hosting and 2 professional email address",
            costMonthly: 0,
            costYearly: 260,
          },
        ],
      },
    },
  ],
}

export const quoteData = morningsideQuoteData
export default morningsideQuoteData
